module.exports = __webpack_public_path__ + "static/blog_back-0736b9b116a6ecbae1ffdfca753be9e6.png";